const onIconClick = (icon) => {
  const formTextField = icon.closest('.form__textfield');
  const inputPwd = formTextField.querySelector('input');
  const type =
    inputPwd.getAttribute('type') === 'password' ? 'text' : 'password';

  inputPwd.setAttribute('type', type);
  formTextField.classList.toggle('form__textfield--eye-open');
};

/**
 * Listen if the icon is clicked for change the input type
 * @param {DOM Element} - Password input
 * @param {DOM Element} - Nodes with icon
 */
export const togglePassword = (eyeIcon) => {
  eyeIcon.forEach((icon) => {
    icon.addEventListener('click', () => onIconClick(icon));
  });
};
